export default class Config {
  constructor(config) {
    this.config = void 0;
    this.config = config;
    if (typeof config !== 'object' || Array.isArray(config) || Object.getOwnPropertyNames(config).length === 0) {
      throw new Error('Config must be instantiated with a non empty configuration object');
    }
  }
  get(path) {
    if (typeof path === 'string') {
      if (typeof this.config[path] !== 'undefined') {
        return this.config[path];
      } else {
        throw new Error(`Missing config ${path}`);
      }
    }
    if (Array.isArray(path)) {
      const drilledValue = path.reduce((result, prop) => result === null ? undefined : result[prop], this.config);
      if (typeof drilledValue !== 'undefined') {
        return drilledValue;
      } else {
        throw new Error(`Missing config ${path.join('.')}`);
      }
    }
    throw new Error(`Path to config value must be a string or array of string`);
  }
}
//# sourceMappingURL=index.js.map